(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/sbtech-api-impl.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/sbtech-api-impl.js');
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

const {
  fns: {
    requests: requestFunctions,
    actions: actionFunctions
  },
  logger,
  betslip,
  yourbet
} = svs.sportsbook.sbtech_api_impl;
const {
  setIframeHeight
} = svs.sportsbook.sbtech_api_impl.utils;
let initialized = false;
svs.sportsbook.sbtech_api_impl.init = (sbtechIframe, sbtechOrigin, token) => {
  if (!sbtechIframe || sbtechIframe.tagName !== 'IFRAME') {
    throw new Error('Element is not an iframe');
  }
  if (!sbtechOrigin) {
    throw new Error('No origin provided');
  }
  if (initialized) {
    throw new Error('SBTech api is already initialized');
  }
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && !token) {
    throw new Error('Missing mandatory token');
  }

  const getToken = () => svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) ? token : null;
  const internals = {
    getToken,
    iframe: sbtechIframe,
    stats: null
  };
  const requests = Object.keys(requestFunctions).reduce((acc, fn) => _objectSpread(_objectSpread({}, acc), {}, {
    [fn]: requestFunctions[fn](data => sbtechIframe.contentWindow.postMessage({
      data,
      name: fn
    }, sbtechOrigin), internals)
  }), {});
  const actions = Object.keys(actionFunctions).reduce((acc, fn) => _objectSpread(_objectSpread({}, acc), {}, {
    [fn]: actionFunctions[fn](data => sbtechIframe.contentWindow.postMessage({
      data,
      name: fn
    }, sbtechOrigin), internals)
  }), {});
  const handleClickSportsbookBetslip = () => {
    const topContentHeight = (document.querySelector('.js-fixed-top-content') || {}).clientHeight || 0;
    actions.goToResponsiveBetSlipCallback();
    window.scrollTo(0, sbtechIframe.offsetTop - topContentHeight);
  };
  const handleSportsbookBetslipStateChange = () => {
    setIframeHeight(sbtechIframe);
  };
  const destroyBetslip = betslip.render(handleClickSportsbookBetslip, handleSportsbookBetslipStateChange);
  const handleClickYourBetButton = () => {
    const topContentHeight = (document.querySelector('.js-fixed-top-content') || {}).clientHeight || 0;
    actions.goToBetBuilderCallback();
    window.scrollTo(0, sbtechIframe.offsetTop - topContentHeight);
  };
  const destroyYourBetButton = yourbet.render(handleClickYourBetButton, sbtechIframe);
  const messageEvent = _ref => {
    let {
      data,
      origin
    } = _ref;
    if (origin !== sbtechOrigin) {
      return;
    }
    const fn = requests[data.name];
    if (fn) {
      fn(data.data);
    } else {
      logger.debug("Receiving event not responding to", data);
    }
  };
  const destroy = () => {
    window.removeEventListener('message', messageEvent);
    destroyBetslip();
    destroyYourBetButton();
    initialized = false;
  };
  window.addEventListener('message', messageEvent);
  initialized = true;
  window.requestIdleCallback(() => {
    const stats = svs.sportsbook.statistics.init();
    internals.stats = stats;
  });
  return {
    actions,
    destroy
  };
};

 })(window);